import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/router';

import BidsComponent from './BidComponent';

export default function BidsTab(props) {
  const [bidsArr, setbidsArr] = useState([]);

  const router = useRouter();
  const { nftId, multiNftId } = router.query;

  useEffect(() => {
    if (props.nftData) {
      if (props.nftData.isMultiple && props.nftData.multipleNftDetails) {
        if (!multiNftId) {
          let lbidsArr = [];
          Object.values(props.nftData.multipleNftDetails).map((ele, index) => {
            if (ele.bids) {
              lbidsArr = lbidsArr.concat(
                Object.values(ele.bids).map((bid) => {
                  return { ...bid, index: ele.index };
                }),
              );
            }
          });
          setbidsArr(lbidsArr);
        } else {
          let arr =
            props.nftData.multipleNftDetails &&
            props.nftData.multipleNftDetails[props.nftData.nftId] &&
            props.nftData.multipleNftDetails[props.nftData.nftId].bids
              ? Object.values(
                  props.nftData.multipleNftDetails[props.nftData.nftId].bids,
                ).map((bid) => {
                  return {
                    ...bid,
                    index:
                      props.nftData.multipleNftDetails[props.nftData.nftId]
                        .index,
                  };
                })
              : [];
          setbidsArr(arr);
        }
      } else if (props?.nftData?.bids) {
        setbidsArr(Object.values(props.nftData.bids));
      }
    }
  }, [props.nftData]);

  console.log('bidsArr', bidsArr);
  return (
    <div className="nft__tab_pane nft__tab__pane--scroll" role="tabpanel">
      <div className="nft__tab_content">
        {props.nftData &&
          props.nftData.nftSaleType === 'Auctioning' &&
          bidsArr &&
          bidsArr
            .sort(function (a, b) {
              return parseFloat(b.timestamp) - parseFloat(a.timestamp);
            })
            .map((ele, index) => {
              return (
                <BidsComponent
                  ele={ele}
                  index={index}
                  nftData={props.nftData}
                />
              );
            })}
        {(() => {
          if (!bidsArr || bidsArr.length === 0) {
            return <p className="text-center">no bids yet</p>;
          }
        })()}
      </div>
    </div>
  );
}
